<ng-template #editDialogContent>
  @let currentFeature = currentFeature$ | async;
  @let layerDetails = layerDetails$ | async;
  @if (currentFeature && layerDetails) {
    <div class="edit-form">
      <div class="content">
        <h2>{{layerDetails.layer.title}}</h2>
        @let editInput = { feature: currentFeature, details: layerDetails.details };
        <tm-edit-form [input]="editInput"
                      (featureAttributeChanged)="featureChanged($event)"
                      (clearUniqueValueCacheAfterSave)="clearUniqueValuesCacheAfterSave($event)"
        ></tm-edit-form>
        <tm-edit-attachments-form [attachmentAttributes]="editInput.details.attachmentAttributes"
                                  [attachmentsByAttributeName]="attachments$ | async"
                                  (newAttachmentsChanged)="onNewAttachmentsChanged($event)"
                                  (deletedAttachmentsChanged)="onDeletedAttachmentsChanged($event)"
        ></tm-edit-attachments-form>
      </div>
      <div class="buttons">
        @if (isCreateFeature$ | async) {
          <button (click)="add(layerDetails.layer.id, editInput)"
                  [disabled]="addOrSaveDisabled(currentFeature, layerDetails.details.geometryAttribute)"
                  color="primary"
                  mat-flat-button>
            @if (creatingSavingFeature()) {
              <mat-spinner diameter="20" mode="indeterminate"></mat-spinner>
            } @else {
              <ng-container i18n="@@core.common.add">Add</ng-container>
            }
          </button>
        } @else {
          <button (click)="save(layerDetails.layer.id, editInput)"
                  [disabled]="addOrSaveDisabled(currentFeature, layerDetails.details.geometryAttribute)"
                  color="primary"
                  mat-flat-button>
            @if (creatingSavingFeature()) {
              <mat-spinner diameter="20" mode="indeterminate"></mat-spinner>
            } @else {
              <ng-container i18n="@@core.common.save">Save</ng-container>
            }
          </button>
          <button (click)="delete(layerDetails.layer.id, currentFeature)"
                  color="warn"
                  [disabled]="removingFeature()"
                  mat-stroked-button>
            @if (removingFeature()) {
              <mat-spinner diameter="20" mode="indeterminate"></mat-spinner>
            } @else {
              <ng-container i18n="@@core.common.delete">Delete</ng-container>
            }
          </button>
        }
        @if (editFeatures().length > 1) {
          <button (click)="backToFeatureList()"
                  i18n="@@core.common.back"
                  mat-flat-button>Back</button>
        } @else {
          <button (click)="closeDialog()"
                  i18n="@@core.common.close"
                  mat-flat-button>Close</button>
        }
      </div>
    </div>
  }

  @let selectableFeatures = selectableFeature$ | async;
  @if (selectableFeatures && selectableFeatures.length > 0) {
    <div class="content">
      <tm-edit-select-feature [features]="selectableFeatures" [inMobilePanel]="inMobilePanel()"></tm-edit-select-feature>
    </div>
    <div class="buttons">
      <button mat-flat-button i18n="@@core.common.close" (click)="closeDialog()">Close</button>
    </div>
  }
</ng-template>

@if (!inMobilePanel()) {
  <tm-dialog [open]="dialogOpen$ | async"
             [openFromRight]="true"
             [width]="panelWidth"
             [widthMargin]="panelWidthMargin"
             class="edit-dialog"
             (closeDialog)="closeDialog()"
             [allowCollapse]="true"
             [collapsed]="dialogCollapsed$ | async"
             (expandCollapseDialog)="expandCollapseDialog()"
             [dialogTitle]="dialogTitle$ | async">
    <ng-container *ngTemplateOutlet="editDialogContent"></ng-container>
  </tm-dialog>
} @else {
  <ng-container *ngTemplateOutlet="editDialogContent"></ng-container>
}

<tm-map-spinner [coordinates$]="editCoordinates$"
                [loading$]="loadingEditFeatureInfo$"></tm-map-spinner>
